import { mapEnumToOptions } from '@abp/ng.core';

export enum StockStatus {
  Ok = 0,
  NotFound = 1,
  Insufficient = 2,
}

export const stockStatusOptions = mapEnumToOptions(StockStatus);
